import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { movieCategories } from '@/mocks/movies';

export default function About() {
  return (
    <>
      <Navbar />

      <main className="pt-16">
        {/* Breadcrumb */}
        <div className="bg-background-100 border-b border-background-200/50">
          <div className="px-4 md:px-6 max-w-7xl mx-auto py-3">
            <nav className="flex items-center gap-2 text-xs text-foreground-500" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors">
                首页
              </Link>
              <i className="ri-arrow-right-s-line text-foreground-400"></i>
              <span className="text-foreground-800 font-medium">关于我们</span>
            </nav>
          </div>
        </div>

        {/* Hero */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="px-4 md:px-6 max-w-4xl mx-auto text-center">
            <h1 className="text-3xl md:text-4xl font-heading text-foreground-900 mb-4">
              关于天堂影院
            </h1>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-2xl mx-auto">
              天堂影院成立于2020年，是一家致力于为全球华语用户提供高清电影在线观看服务的免费电影网站。我们汇聚最新电影在线观看、电影大全资源，以高清不缓冲流畅在线观看和极速播放无广告为核心优势，打造极致的观影体验。
            </p>
          </div>
        </section>

        {/* Brand Story */}
        <section className="py-10 md:py-14 bg-background-100">
          <div className="px-4 md:px-6 max-w-5xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-10 items-center">
              <div className="flex-shrink-0 w-full lg:w-96">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20luxurious%20cinema%20lobby%20with%20warm%20golden%20lighting%2C%20red%20velvet%20seats%2C%20elegant%20movie%20theater%20interior%2C%20professional%20architectural%20photography%2C%20warm%20atmosphere%2C%20clean%20composition&width=600&height=450&seq=about-brand-story&orientation=landscape"
                  alt="天堂影院 - 品牌故事"
                  title="天堂影院品牌故事"
                  className="w-full rounded-lg"
                />
              </div>
              <div className="flex-1">
                <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-4">
                  品牌故事
                </h2>
                <div className="space-y-3 text-sm text-foreground-600 leading-relaxed">
                  <p>
                    天堂影院的诞生源自创始团队对电影的热爱。2020年，一群资深电影爱好者和技术专家发现，市面上大多数免费电影网站要么充斥着大量广告，要么播放体验差强人意。于是，他们决定打造一个真正以用户体验为核心的免费在线观影平台。
                  </p>
                  <p>
                    经过三年的技术积累和内容建设，天堂影院已发展成为华语地区最受欢迎的免费电影网站之一。我们拥有超过20000部高清影视资源，涵盖动作、科幻、喜剧、剧情、恐怖、动画、纪录片、爱情等全部主流类型。
                  </p>
                  <p>
                    我们的使命很简单：<strong>让每一个热爱电影的人，都能随时随地享受高品质的观影体验。</strong>我们相信，好的电影不应该被广告打断，高清画质不应该只是付费用户的特权。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="py-10 md:py-14 bg-background-50">
          <div className="px-4 md:px-6 max-w-5xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-8">
              {[
                { value: '20,000+', label: '影视资源', icon: 'ri-film-line' },
                { value: '5,000万+', label: '累计用户', icon: 'ri-user-line' },
                { value: '99.9%', label: '播放成功率', icon: 'ri-check-double-line' },
                { value: '24/7', label: '内容更新', icon: 'ri-refresh-line' },
              ].map((stat) => (
                <div key={stat.label} className="text-center p-5 rounded-lg bg-background-100 border border-background-200/60">
                  <div className="w-10 h-10 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                    <i className={`${stat.icon} text-lg text-primary-500`}></i>
                  </div>
                  <div className="text-2xl md:text-3xl font-bold text-primary-500 mb-1 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* User Reviews */}
        <section className="py-10 md:py-14 bg-background-100">
          <div className="px-4 md:px-6 max-w-5xl mx-auto">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
                用户口碑
              </h2>
              <p className="text-sm text-foreground-500">
                听听我们的用户怎么说
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {[
                {
                  name: '张先生',
                  role: '电影爱好者',
                  text: '用了天堂影院两年了，真的没有任何广告！画质超清晰，加载速度也很快。我推荐给身边所有喜欢看电影的朋友。',
                  rating: 5,
                },
                {
                  name: '李女士',
                  role: '家庭主妇',
                  text: '周末全家人一起用天堂影院看电影，孩子看动画片，我和老公看科幻片。分类很全，操作也很简单，老人小孩都会用。',
                  rating: 5,
                },
                {
                  name: '王同学',
                  role: '大学生',
                  text: '宿舍网速一般，但天堂影院的缓冲速度真的快！而且片库更新很快，新上映的电影过不了多久就能看到了。强烈推荐！',
                  rating: 5,
                },
              ].map((review) => (
                <div
                  key={review.name}
                  className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/60"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: review.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    &ldquo;{review.text}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center">
                      <span className="text-xs font-medium text-secondary-700">
                        {review.name.charAt(0)}
                      </span>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-800">{review.name}</div>
                      <div className="text-xs text-foreground-400">{review.role}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="py-10 md:py-14 bg-background-50">
          <div className="px-4 md:px-6 max-w-5xl mx-auto">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
                联系我们
              </h2>
              <p className="text-sm text-foreground-500">
                有任何问题或建议，欢迎随时联系我们
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
              {[
                {
                  icon: 'ri-mail-line',
                  title: '电子邮箱',
                  value: 'contact@ttcinema.com',
                  href: 'mailto:contact@ttcinema.com',
                },
                {
                  icon: 'ri-phone-line',
                  title: '客服电话',
                  value: '400-888-8888',
                  href: 'tel:400-888-8888',
                },
                {
                  icon: 'ri-map-pin-line',
                  title: '公司地址',
                  value: '北京市朝阳区光华路88号',
                  href: null,
                },
              ].map((item) => (
                <div key={item.title} className="p-5 rounded-lg bg-background-100 border border-background-200/60 text-center">
                  <div className="w-10 h-10 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                    <i className={`${item.icon} text-lg text-primary-500`}></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-800 mb-2">{item.title}</h3>
                  {item.href ? (
                    <a href={item.href} className="text-sm text-primary-500 hover:text-primary-600 transition-colors">
                      {item.value}
                    </a>
                  ) : (
                    <p className="text-sm text-foreground-600">{item.value}</p>
                  )}
                </div>
              ))}
            </div>

            {/* FAQ */}
            <div>
              <h3 className="text-xl font-heading text-foreground-900 mb-6 text-center">
                常见问题
              </h3>
              <div className="space-y-3 max-w-3xl mx-auto">
                {[
                  {
                    q: '天堂影院真的完全免费吗？',
                    a: '是的，天堂影院所有影片完全免费在线观看。不需要注册，不需要付费，也不需要购买任何会员。我们通过其他方式维持运营，不会向用户收取任何费用。',
                  },
                  {
                    q: '为什么没有广告？',
                    a: '这是我们与其他免费电影网站最大的区别。我们坚信好的观影体验不应该被广告打断。通过优化技术架构和运营模式，我们可以在不插播广告的情况下持续运营。',
                  },
                  {
                    q: '支持哪些设备观看？',
                    a: '天堂影院全面支持电脑（Windows/Mac）、平板（iPad/Android）、手机（iOS/Android）等所有主流设备。同时支持AirPlay投屏功能，可以将影片投射到大屏幕电视上观看。',
                  },
                  {
                    q: '画质怎么样？需要缓冲吗？',
                    a: '我们所有影片均采用1080P高清画质，部分热门影片甚至提供4K超清版本。借助全球CDN加速网络，无论您身在何处，都能实现高清不缓冲的流畅播放体验。',
                  },
                  {
                    q: '片库多久更新一次？',
                    a: '我们的片库每天都在更新，新上映的电影通常在院线下映后的一到两周内就会上线。同时我们也会不断补充经典老片和海外佳作，确保片库的丰富性和时效性。',
                  },
                ].map((faq, idx) => (
                  <details
                    key={idx}
                    className="group rounded-lg bg-background-100 border border-background-200/60 overflow-hidden"
                  >
                    <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-200/50 transition-colors">
                      <span className="text-sm font-medium text-foreground-800 pr-4">{faq.q}</span>
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform flex-shrink-0"></i>
                    </summary>
                    <div className="px-5 pb-4">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "关于天堂影院",
            description:
              "天堂影院成立于2020年，致力于为全球华语用户提供高清电影在线观看服务。高清不缓冲流畅在线观看，极速播放无广告。",
            breadcrumb: {
              "@type": "BreadcrumbList",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "首页",
                  item: "https://www.ttcinema.com",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "关于我们",
                },
              ],
            },
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "天堂影院真的完全免费吗？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "是的，天堂影院所有影片完全免费在线观看。不需要注册，不需要付费，也不需要购买任何会员。",
                },
              },
              {
                "@type": "Question",
                name: "为什么没有广告？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "这是我们与其他免费电影网站最大的区别。我们坚信好的观影体验不应该被广告打断。",
                },
              },
              {
                "@type": "Question",
                name: "支持哪些设备观看？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "天堂影院全面支持电脑、平板、手机等所有主流设备。同时支持AirPlay投屏功能。",
                },
              },
              {
                "@type": "Question",
                name: "画质怎么样？需要缓冲吗？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "所有影片均采用1080P高清画质，借助全球CDN加速网络实现高清不缓冲的流畅播放体验。",
                },
              },
              {
                "@type": "Question",
                name: "片库多久更新一次？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "片库每天都在更新，新上映电影通常在院线下映后一到两周内上线，同时不断补充经典老片和海外佳作。",
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}